import React, { useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEditViewStockAudit from "../../../components/inventory/stock-audit/create-edit-view-stock-audit";

const AddStockAudit = () => {
  const [loading, setLoading] = useState(false);

  return (
    <InnerLayout backBtn={true} title="Stock Audit">
      <CreateEditViewStockAudit
        disabled={false}
        loading={loading}
        setLoading={setLoading}
      />
    </InnerLayout>
  );
};

export default AddStockAudit;
